export default {
  codeDetail: {},
  codeDetailMatriculados: []
}
